<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">جدول شارژ کیف پول   </h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                ">
                                <a-button class="btn-outline-purple" icon="search" @click="isHidden = !isHidden">
                                    جستجو
                                </a-button>
                                &nbsp;
                               <ExportWallet />
                            </a-col>
                        </a-row>
                    </template>

                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
                            <a-col style="margin-top: 25px" :md="4">
                                <a-button class="btn-outline-green w-100" icon="search" @click="getData">
                                    جستجو
                                </a-button>

                            </a-col>
                            <div class="row">
                              <div class="col-md-4 my-1">
                                <label class="sr-only" for="inline-form-input-name">  شماره پیگیری</label>
                                    <input type="text" v-model="search.tracking_code" class="form-control" />                            
                                    </div>
                              <div class="col-md-4 my-1">
                                <UserSearch @ids="getIds" />
                               
                            </div>
                            <div class="col-md-4 my-1">
                                <label class="sr-only" for="inline-form-input-name">  وضعیت سفارش</label>
                                <a-select mode="multiple" style="width:100%" placeholder="  انتخاب وضعیت "
                                    v-model="search.order_status_id">
                                    <a-select-option v-for="status in statuses" :key="status.id" :value="status.id">
                                        {{ status . title  }}
                                    </a-select-option>
                                </a-select>
                            </div>
                            </div>
                                                </b-card>
                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                                                            <div class="table-responsive">

                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">شناسه</th>
                                        <th scope="col">خریدار</th>
                                        <th scope="col"> قیمت نقدی</th>
                                        <th scope="col"> شماره پیگیری</th>
                                        <th scope="col">  تاریخ پرداخت</th>
                                        <th scope="col">   وضعیت سفارش</th>

                                        <th scope="col"> مشاهده</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in data">
                                        <th scope="row">#{{ row . id }}</th>
                                        <td>

                                            <b-badge variant="light" class="text-dark">
                                                {{row.user ?  $root.full_name(row . user . firstname , row . user . lastname) : '' }}</b-badge>
                                        </td>
                                        <td>
                                            <b-badge variant="light" class="bg-secondary">
                                                {{ $root . number_format(row . total) }}</b-badge>


                                        </td>

                                      

                                        <td>
                                            <b-badge variant="light" class="bg-success">{{ row . tracking_code }}</b-badge>
                                        </td>
                                        <td>
                                            <b-badge variant="light" class="text-dark">{{row . paid_date != null ? new Date(row . paid_date).toLocaleDateString('fa-IR') : '-' }}</b-badge>
                                        </td>
                                        <td>
                                            <b-badge variant="light" class="bg-muted">{{ row . status.title }}</b-badge>
                                        </td>
                                        <td>
                                            <a-button class="btn-outline-info" shape="square" icon="eye" :href="'/orders/detail/'+row.id" />
                                            &nbsp;
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row>
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import UserSearch from "../../components/Blocks/UserSelectMultiple.vue"
    import ExportWallet from "../../components/Blocks/ExportWallet.vue"

    export default {
        components: {
            
            UserSearch,
            ExportWallet
        },
        data() {
            return {
                data: [],
                statuses: [],
                currentPage: 1,
                total: 0,
                isHidden: false,
                search: {
                  user_id: [],
                  order_status_id:[],
                  tracking_code:""
                },
            };
        },
        methods: {
            getIds(value) {
                this.search.user_id=value
            },
            async getData() {
                let _this = this;
                this.$store.state.loading = true;
                let url = `/orders?page=${this.currentPage}&&user_id=${this.search.user_id}&&order_status_id=${this.search.order_status_id}&&tracking_code=${this.search.tracking_code}&&wallet=1`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.data = response.data.data;
                        _this.$store.state.loading = false;
                        _this.total = response.data.total;
                        _this.currentPage = response.data.current_page;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            async getStatuses() {
                let _this = this;
                let url = '/orders/statuses';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.statuses = response.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
        },
        mounted() {
            this.getData();
            this.getStatuses();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
